<template>
  <div class="Assignment">
    <p class="line">
        <b></b>欠款人信息
    </p>
    <ul>
        <li style="margin-right: 20%;">
            <span>姓名：</span>
            <el-input v-model="name" placeholder="" class="input"></el-input>
        </li>
        <li>
            <span>身份证号(选填)：</span>
            <el-input v-model="id" placeholder="" class="input"></el-input>
        </li>
        <li style="margin-right: 20%;">
            <span>手机号(选填)：</span>
            <el-input v-model="tel" placeholder="" class="input"></el-input>
        </li>
        <li>    
            <span>是否失联：</span>
            <el-radio v-model="radio1" label="已失联">已失联</el-radio>
            <el-radio v-model="radio1" label="未失联">未失联</el-radio>
        </li>
        <li style="margin-right: 20%;">
            <span>所在地：</span>
            <el-select v-model="province" placeholder="请选择" style="width:25%" @change="handleChange1(province)">
                <el-option
                v-for="item,index in province_list"
                :key="index"
                :label="item.ss_name"
                :value="index">
                </el-option>
            </el-select>
            <el-select v-model="city" placeholder="请选择" style="width:25%" @change="handleChange2(city)">
                <el-option
                v-for="item,index in city_list"
                :key="index"
                :label="item.ss_name"
                :value="index">
                </el-option>
            </el-select>
            <el-select v-model="qu" placeholder="请选择" style="width:25%">
                <el-option
                v-for="item,index in qu_list"
                :key="index"
                :label="item.ss_name"
                :value="index">
                </el-option>
            </el-select>
        </li>
        <li>
            <span>详细地址：</span>
            <el-input v-model="detail_ad" placeholder="" class="input"></el-input>
        </li>
    </ul>


    <div class="check">
        <button style="opacity:0;cursor: initial;">上一步</button>
        <button class="active" @click="nextone()">下一步</button>
    </div>

  </div>
</template>

<script>
export default {
  props:{

  },
  data () {
    return {
        name: '',
        id:'',
        tel:'',
        radio1:'未失联',
        detail_ad:'',
        // 三级联动
        province:'',
        province_list:[],
        city:'',
        city_list:[],
        qu:'',
        qu_list:[]
        

    }
  },
  components:{

  },
  mounted(){
    this.getcity();
    if(window.sessionStorage.getItem('Assignment1')){
        var info = JSON.parse(window.sessionStorage.getItem('Assignment1'));
        this.name = info.name;
        this.id = info.id;
        this.tel = info.tel;
        this.radio1 = info.radio1;
        this.detail_ad = info.detail_ad;
    }  
  },
  methods: {
    getcity(a){
        if(!a){
            // 获取省份列表
            var _this = this;
            this.$http.post(api.getcity).then(function(res){
                if(res.data.code == 100001){
                    // console.log(res.data.data);
                    _this.province_list = res.data.data;
                    _this.province = _this.province_list[0].ss_name;
                    _this.getcity(_this.province_list[0].ss_code);
                }else{

                };
            })
        }else{
            // 获取城市列表
            var _this = this;
            let param = new URLSearchParams();
            param.append("province", a);
            this.$http.post(api.getcity,param).then(function(res){
                if(res.data.code == 100001){
                    // console.log(res.data.data);
                    _this.city_list = res.data.data;
                    _this.city = _this.city_list[0].ss_name;
                    _this.getqu(_this.city_list[0].ss_code)
                }else{

                };
            })
        }
    },
    getqu(id){
        var _this = this;
        let param = new URLSearchParams();
        param.append("city", id);
        this.$http.post(api.getcity,param).then(function(res){
            if(res.data.code == 100001){
                // console.log(res);
                _this.qu_list = res.data.data;
                _this.qu = _this.qu_list[0].ss_name;
            }else{

            };
        })
    },
    handleChange1(value) {
        this.getcity(this.province_list[value].ss_code);
    },
    handleChange2(value) {
        this.getqu(this.city_list[value].ss_code)
    },
    nextone(){
        if(this.name == ''){
          this.$message.error('请填写欠款人真实姓名');
          return
        }else if(this.detail_ad == ''){
          this.$message.error('请填写欠款人详细地址');
          return
        }
        // 数据缓存本地
        var obj = new Object();
        obj.name = this.name;
        obj.id = this.id;
        obj.tel = this.tel;
        obj.radio1 = this.radio1;
        obj.detail_ad = this.detail_ad;
        var a = JSON.stringify(obj);
        window.sessionStorage.setItem('Assignment1',a);

        // ***跳转
        // this.$emit('son','2')
        // return;
        // --------------------------
        var _this = this;
        // return
        let param = new URLSearchParams();
        param.append("flag", '1');
        param.append("debt_name", this.name);
        param.append("debt_idcard", this.id);
        param.append("debt_mobile", this.tel);
        param.append("debt_lost", this.radio1);
        param.append("debt_province", typeof(this.province)=='string'?this.province:this.province_list[this.province].ss_name);
        param.append("debt_city", typeof(this.city)=='string'?this.city:this.city_list[this.city].ss_name);
        param.append("debt_area", typeof(this.qu)=='string'?this.qu:this.qu_list[this.qu].ss_name);
        param.append("debt_area_ext", this.detail_ad);
        this.$http.post(api.Assignment,param).then(function(res){
            if(res.data.code == 100001){
                window.sessionStorage.setItem('orderid',res.data.data.orderid);
                _this.$emit('son','2')
            }else{
                _this.$message.error(res.data.message);
            }
        })

        
    }
  }
}



</script>

<style scoped >

.Assignment{
    background:#FFFFFF;
    padding: 3% 3%;
}
.Assignment .line{
    color: #2fb8c2;
    font-weight: bold;
}
.Assignment .line b{
    display: inline-block;
    width: 5px;
    background: #2fb8c2;
    height: 20px;
    vertical-align: bottom;
    margin-right: 1rem;
    border-radius: 10px;
}
.Assignment ul{
    overflow:hidden;
    font-size:0.8rem;
}
.Assignment ul li{
    float:left;
    box-sizing: border-box;
    width:40%;
    margin-top: 10px;
    padding: 30px 0;
    border-bottom: 1px solid #d3d3d3;
    height: 100px;
    
}
.Assignment ul li span{
    display: inline-block;
    width: 21%;
    text-align:left;
}
.Assignment ul li>label{
    text-align:center;
    width:35%
    
}
.select{
    text-align: right;
}
.select span{
    float:left;
    line-height:40px;
}
.check{
    padding-top: 3%;
    text-align:center;
}
.check button{
    border: none;
    outline: none;
    padding: 20px 50px;
    border-radius: 10px;
    background: #FFFFFF;
    border: 1px solid #d3d3d3;
    margin: 0 50px;
    cursor: pointer;
}
.check button:hover{
    background:#2fb8c2;
    color:#ffffff;
}
.check button.active{
    background:#2fb8c2;
    color:#ffffff;
}
.input{
    width:75%
}


</style>



// WEBPACK FOOTER //
// src/common/Assignment1.vue